import { render } from "./Returns.vue?vue&type=template&id=d45589f4&ts=true"
import script from "./Returns.vue?vue&type=script&lang=ts"
export * from "./Returns.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__